<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div style="margin-top: -7rem !important;">
    <div class="page-header-card mb-3" :class="{ 'nav-orange-gradient-bg' : $getSiteId() == 33, 'nav-green-gradient-bg' : $getSiteId() == 35 }">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-2 mt-5">
            <div class="vx-col w-full text-center">
              <custom-svg variant="help" width="70" height="70" color="white" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-center">
              <h2 style="color: white">need support?</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-overlay
      id="support-overlay-background"
      :show="overlayActive"
      variant="tranparent"
      opacity=0.85
      blur="5px"
    >
      <template #overlay>
        <div class="overlay-content text-center">
          <b-icon icon="stopwatch" font-scale="3" animation="throb"></b-icon>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
      <div v-if="!supportFormActive" class="mx-4" style="margin-top: -70px;">
        <div style="border-radius: 30px; background-color: rgba(0,0,0,0.5);" class="mb-3 green-border border-3px cursor-pointer" @click="showSupportForm('technical')">
          <div class="vx-row menu-item-container-of-content">
            <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
              <div class="vx-row">
                <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                  <custom-svg class="menu--icon settings--icon" variant="settings" color="gradient-green" />
                </div>
                <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                  <div class="vx-row">
                    <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                      <p class="mb-n2 font-gen2-gradient-green sonke-menu-heading" style="font-weight: 600;letter-spacing: -2px;">technical</p>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                      <h4 class="sonke-menu-sub-heading">support</h4>
                    </div>
                  </div>
                </div>
                <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                  <custom-svg class="menu--icon arrow--icon" variant="arrow" color="gradient-green" dir="right" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="border-radius: 30px; background-color: #ffffff;" class="mb-3 green-border border-3px cursor-pointer" @click="showSupportForm('learning')">
          <div class="vx-row menu-item-container-of-content">
            <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
              <div class="vx-row">
                <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                  <custom-svg class="menu--icon globe--icon" variant="globe" color="gradient-green" />
                </div>
                <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                  <div class="vx-row">
                    <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                      <p class="mb-n2 font-gen2-gradient-green sonke-menu-heading" style="font-weight: 600;letter-spacing: -2px;">learning</p>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                      <h4 class="sonke-menu-sub-heading" style="color: #929292">support</h4>
                    </div>
                  </div>
                </div>
                <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                  <custom-svg class="menu--icon arrow--icon" variant="arrow" color="gradient-green" dir="right" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMentoringAvailable" style="border-radius: 30px; background-color: #ffffff;" class="mb-3 green-border border-3px cursor-pointer" @click="showSupportForm('mentorship')">
          <div class="vx-row menu-item-container-of-content">
            <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
              <div class="vx-row">
                <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                  <custom-svg class="menu--icon chat--icon" variant="chat" color="gradient-green" />
                </div>
                <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                  <div class="vx-row">
                    <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                      <p class="mb-n2 font-gen2-gradient-green sonke-menu-heading" style="font-weight: 600;letter-spacing: -2px;">mentorship</p>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                      <h4 class="sonke-menu-sub-heading" style="color: #929292">support</h4>
                    </div>
                  </div>
                </div>
                <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                  <custom-svg class="menu--icon arrow--icon" variant="arrow" color="gradient-green" dir="right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else id="support-form" class="mx-4 text-left">
        <vs-divider><h4>{{ supportHeading }}</h4></vs-divider>
        <div class="mb-3">
          <h5 class="ml-4">Your WhatsApp Number</h5>
          <cleave
            id="support-whatsapp"
            v-model="errorData.whatsappNumber"
            class="form-control"
            :raw="false"
            :options="options.prefix"
          />
        </div>
        <div class="mb-3">
          <h5 class="ml-4">Message</h5>
          <vs-textarea v-model="errorData.userMessage" />
        </div>
        <!-- <div class="vx-row">
          <div class="vx-col w-2/3">
            <vs-button class="w-full" type="gradient" color="#20AA34" gradient-color-secondary="#97c360" @click="submitIssue">submit</vs-button>
          </div>
          <div class="vx-col w-1/3">
            <vs-button class="w-full" color="warning" type="border" @click="cancelSupport">cancel</vs-button>
          </div>
        </div> -->
        <div class="vx-row">
          <div class="vx-col w-full mb-3">
            <vs-button class="w-full" type="gradient" color="#20AA34" gradient-color-secondary="#97c360" icon-pack="feather" icon="icon-check" @click="submitIssue">submit</vs-button>
          </div>
          <div class="vx-col w-full">
            <vs-button class="w-full" color="warning" type="border" icon-pack="feather" icon="icon-x" @click="cancelSupport">cancel</vs-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import Cleave from 'vue-cleave-component'
export default {
  components: {
    CustomSvg,
    Cleave
  },
  data() {
    return {
      isMentoringAvailable: false,
      supportFormActive: false,
      supportHeading: "",
      errorData: {
        taskId: null,
        userMessage: "",
        osName: "",
        osVersion: "",
        browserName: "",
        browserVersion: "",
        navigatorUserAgent: "",
        navigatorAppVersion: "",
        navigatorPlatform: "",
        navigatorVendor: "",
        isMobile: false,
        whatsappNumber: ""
      },
      options: {
        prefix: {
          // prefix: '+27',
          blocks: [3, 3, 4]
        },
      },
      overlayActive: false
    };
  },
  computed: {
    
  },
  methods: {
    showSupportForm(heading) {
      this.supportFormActive = true;
      this.supportHeading = `${heading} support`;
    },
    cancelSupport() {
      this.supportFormActive = false;
      this.errorData.whatsappNumber = "";
      this.errorData.userMessage = "";
    },
    submitIssue() {
      var self = this;

      var isNumberValid = self.errorData.whatsappNumber.replace(/ /g,'')[0] == "0" ? true : false;

      if (!self.errorData.userMessage) {
        self.$swal({
          position: 'center',
          icon: 'error',
          title: 'please enter a message',
          showConfirmButton: true,
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled'
          },
          buttonsStyling: false,
        })
        return;
      }
      
      if (isNumberValid) {
        self.overlayActive = true;
        self.errorData.isMobile = self.isMobile();
        
        var onSuccess = response => {
          self.$swal({
            position: 'center',
            icon: 'success',
            title: `${self.supportHeading} query created!`,
            showConfirmButton: false,
            timer: 2000
          });
        };

        var onFinally = response => {
          self.overlayActive = false;
          self.supportFormActive = false;
        };

        self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess, onFinally);
      } else {
        self.$swal({
          position: 'center',
          icon: 'error',
          title: 'please enter a valid WhatsApp number',
          showConfirmButton: true,
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled'
          },
          buttonsStyling: false,
        })
      }
    },
    setDeviceType() {
      var self = this;

      var module = {
        options: [],
        header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
        dataos: [
          { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
          { name: 'Windows', value: 'Win', version: 'NT' },
          { name: 'iPhone', value: 'iPhone', version: 'OS' },
          { name: 'iPad', value: 'iPad', version: 'OS' },
          { name: 'Kindle', value: 'Silk', version: 'Silk' },
          { name: 'Android', value: 'Android', version: 'Android' },
          { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
          { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
          { name: 'Macintosh', value: 'Mac', version: 'OS X' },
          { name: 'Linux', value: 'Linux', version: 'rv' },
          { name: 'Palm', value: 'Palm', version: 'PalmOS' },
          { name: 'Huawei', value: 'Huawei', version: 'OS' }
        ],
        databrowser: [
          { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
          { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
          { name: 'Safari', value: 'Safari', version: 'Version' },
          { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
          { name: 'Opera', value: 'Opera', version: 'Opera' },
          { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
          { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' },
          { name: 'Huawei Browser', value: 'Huawei Browser', version: 'Huawei' }
        ],
        init: function () {
          var agent = this.header.join(' '),
            os = this.matchItem(agent, this.dataos),
            browser = this.matchItem(agent, this.databrowser);

          return { os: os, browser: browser };
        },
        matchItem: function (string, data) {
          var i = 0,
            j = 0,
            html = '',
            regex,
            regexv,
            match,
            matches,
            version;

          for (i = 0; i < data.length; i += 1) {
            regex = new RegExp(data[i].value, 'i');
            match = regex.test(string);
            if (match) {
              regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
              matches = string.match(regexv);
              version = '';
              if (matches) { if (matches[1]) { matches = matches[1]; } }
              if (matches) {
                matches = matches.split(/[._]+/);
                for (j = 0; j < matches.length; j += 1) {
                  if (j === 0) {
                    version += matches[j] + '.';
                  } else {
                    version += matches[j];
                  }
                }
              } else {
                version = '0';
              }
              return {
                name: data[i].name,
                version: parseFloat(version)
              };
            }
          }
          return { name: 'unknown', version: 0 };
        }
      };

      var e = module.init();

      self.errorData.osName = e.os.name;
      self.errorData.osVersion = e.os.version;
      self.errorData.browserName = e.browser.name;
      self.errorData.browserVersion = e.browser.version;
      self.errorData.navigatorUserAgent = navigator.userAgent;
      self.errorData.navigatorAppVersion = navigator.appVersion;
      self.errorData.navigatorPlatform = navigator.platform;
      self.errorData.navigatorVendor = navigator.vendor;
    },
  },
  mounted() {
    this.isMentoringAvailable = localStorage.getItem("mentoringAvailable") === "true" || false;
    this.setDeviceType();
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>